import type { EntityConfig } from '../types'

export const mmCollectedFeeEntity: EntityConfig = {
  name: 'mm-collected-fee',
  label: 'Collected Fee',
  pluralLabel: 'Collected Fees',
  status: {
    field: 'status',
    options: [
      { value: 'collected', label: 'Collected', variant: 'success' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'failed', label: 'Failed', variant: 'destructive' },
      { value: 'waived', label: 'Waived', variant: 'secondary' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'collected', label: 'Collected' },
      { value: 'pending', label: 'Pending' },
      { value: 'failed', label: 'Failed' },
      { value: 'waived', label: 'Waived' },
    ],
    mappings: {
      all: ['collected', 'pending', 'failed', 'waived'],
      collected: ['collected'],
      pending: ['pending'],
      failed: ['failed'],
      waived: ['waived'],
    }
  },
  queryFields: {
    description: { field: 'description', type: 'text' },
    type: { field: 'type', type: 'text' },
    merchantName: { field: 'merchantName', type: 'text' },
  },
  uiFilterFields: ['status', 'type'],
}
